import React, { ReactElement } from 'react';

export default function NotFoundPage(): ReactElement {
	return (
		<div className={'text-center'}>
			<h1>404 Not Found</h1>
		</div>
	);
}
